import React from 'react'
import { Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import CustomButton from '../../shared/CustomButton';

const ChangePassword = ({
  isSaving,
  formAction
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
    setError,
    getValues
  } = useForm();

  const resetForm = () => {
    reset({
      current_password: '',
      password: '',
      password_confirmation: ''
    });
  }

  const onSubmit = async (data) => {
    try {
      const success = await formAction(data);
      if (success){
        resetForm();
      }
    } catch (error) {
      resetForm();
      if (error.response && error.response.status === 422){
        Object.keys(error.response.data.errors).forEach((field) => {
          setError(field, {
            type: 'manual',
            message: error.response.data.errors[field][0]
          });
        });
      } else {
        throw error; // non 422 API errors will be handled in handleChangePassword() in Header.jsx
      }
    }
  }
  return (
    
    <Form onSubmit={handleSubmit(onSubmit)}>

      <Form.Group>

        <Form.Label htmlFor='current_password'>Current Password</Form.Label>
        <input type='password' placeholder='Current Password'
          className={`form-control ? ${errors.current_password ? 'is-invalid' : ''}`}
          {...register('current_password', {
            required: 'Enter your current password'
          })}
        />
        {errors.current_password && (
          <div className="invalid-feedback">{errors.current_password.message}</div>
        )}

      </Form.Group>

      <Form.Group>

        <Form.Label htmlFor='password'>New Password</Form.Label>
        <input type='password' placeholder='New Password'
          className={`form-control ? ${errors.password ? 'is-invalid' : ''}`}
          {...register('password', {
            required: 'Enter your new password',
          })}
        />
        {errors.password && (
          <div className="invalid-feedback">{errors.password.message}</div>
        )}

      </Form.Group>

      <Form.Group>

        <Form.Label htmlFor='password_confirmation'>Confirm Password</Form.Label>
        <input type='password' placeholder='Current Password'
          className={`form-control ? ${errors.password_confirmation ? 'is-invalid' : ''}`}
          {...register('password_confirmation', {
            required: 'Confirm your new password',
            validate: (value) => value === getValues('password') || 'Passwords do not match'
          })}
        />
        {errors.password_confirmation && (
          <div className="invalid-feedback">{errors.password_confirmation.message}</div>
        )}
        
      </Form.Group>

      <CustomButton
        title={isSaving ? 'Changing Password' : 'Change Password'}
        isSaving={isSaving}
      />
    
    </Form>
  )
}

export default ChangePassword